const currency = {
  USD: '&#x24',
  INR: '&#8377'
}

const URL = {
  MARKET_URL: `outlet/`,
  BUSINESS_URL: `business/`,
  FEEDBACK_URL: `feedback/`,
  LOGO_URL: 'https://static.apps.dev.ristasales.com/logo'
}

const dataMap = {
  daysArr: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  paymentStatus: ['Requested', 'Posted', 'Failed'],
  deliveryMode: {
    DELIVERY: 'Delivery',
    PICKUP: 'Pickup',
    IN_STORE: 'In Store'
  },
  deliveryModeLbl: {
    DELIVERY: 'Deliver',
    PICKUP: 'Pickup'
  },
  googleMapsAPIKey: 'AIzaSyC3RbBRDbaV5sT4y4KLfc74-Oes5j0CfyQ'
}

export default {
  namespaced: true,
  currency,
  URL,
  dataMap
}
